import { render, staticRenderFns } from "./magesDungeon.vue?vue&type=template&id=5d83790f&"
import script from "./magesDungeon.vue?vue&type=script&lang=js&"
export * from "./magesDungeon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports